module.exports = __webpack_public_path__ + "static/media/31JFA11.9fd659b8.jpg";